<template>
    <div>
        <div class="panel" v-if="loaded && !error && !isUsersSolution">
            <div class="panel-body">
                <div class="row">
                    <div class="col-xs-12">
                        <h4 class="panel-title"><strong>Deine Bewertung</strong></h4>
                    </div>
                </div>
                <div class="row">
                    <div v-if="!loaded && !error" class="col-xs-12">
                        <div style="height: 10vh;">
                            <p class="text-center"
                               style="position:absolute; top: 45%; width: 100%;">
                            <span class="fa fa-cog fa-spin fa-5x"
                                  style="color: #41a499; font-family: FontAwesome !important;">
                            </span>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-12">
                        <form v-on:submit.prevent="sendRankingForm()">
                            <div class="form-group">
                                <div class="col-xs-12" v-if="hasErrorMessageForField('rate')">
                                    <div
                                            class="alert alert-danger alert-dismissible"
                                            role="alert">
                                        <p v-for="message of getErrorMessageForField('rate')">
                                            {{message}}</p>
                                    </div>
                                </div>
                                <star-rating id="rate" @changedValue="setRate" name="rate"
                                             :value="ratingPostData.rate"></star-rating>
                            </div>
                            <div class="form-group">
                                <div class="alert alert-info">
                                  Versuch, dein Rating so transparent wie möglich zu gestalten. Was gefällt dir an der Lösung, was nicht?
                                  Das hilft Usern, ihre erhaltenen Bewertungen besser nachzuvollziehen und daraus zu lernen.
                                </div>
                                <div class="" v-if="hasErrorMessageForField('comment')">
                                    <div
                                            class="alert alert-danger alert-dismissible"
                                            role="alert">
                                        <p v-for="message of getErrorMessageForField('comment')">
                                            {{message}}</p>
                                    </div>
                                </div>
                                <input type="text" class="form-control comment-input" id="comment"
                                       v-model="ratingPostData.comment"
                                       placeholder="Was für ein cooler Code ..."
                                       :maxlength="maxCommentLength">
                                  <text-length-indicator :text="ratingPostData.comment" :max-text-length="maxCommentLength"/>
                            </div>
                            <div class="row">
                                <div class="col-xs-12 col-md-12 col-lg-12 text-right">
                                    <button class="btn submit-ranking-button btn-primary" type="submit">
                                      <i class="dev-star"></i>
                                        Rank it
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {services} from "../../main";
    import StarRating from "../StarRating";
    import TextLengthIndicator from "../TextLengthIndicator";

    export default {
        name: "RatingFormComponent",
        components: {TextLengthIndicator, StarRating},
        props: {
            solutionId: {type: String, required: true},
            challengeId: {type: String, required: false}
        },
        data() {
            return {
                solutionRequest: services.rankTheCodeService.getSolution(this.solutionId),
                ratingPostResult: {loaded: true, error: false},
                ratingPostData: {
                    rate: 0,
                    comment: "",
                },
                next: false,
                maxCommentLength: 255,
            }
        },
        computed: {
            loaded: function () {
                return this.solutionRequest.loaded;
            },
            error: function () {
                return this.solutionRequest.error;
            },
            isUsersSolution: function () {
                return this.solutionRequest.apiData.isUsersSolution;
            },
        },
        methods: {
            setRate(rate) {
                this.ratingPostData.rate = rate;
            },
            hasErrorMessageForField(field) {
                return this.ratingPostResult.error && this.ratingPostResult.error.additionalData && this.ratingPostResult.error.additionalData.fields[field]
            },
            getErrorMessageForField(field) {
                return this.ratingPostResult.error.additionalData.fields[field]
            },
            sendRankingForm() {
                this.ratingPostResult = services.rankTheCodeService.postRating(this.solutionId, this.ratingPostData.rate, this.ratingPostData.comment);
            },
        },
        watch: {
            "solutionRequest.loaded": function () {
                if (this.solutionRequest.loaded && !this.solutionRequest.error) {
                    if (this.solutionRequest.apiData.usersRating) {
                      this.ratingPostData = {
                        rate: this.solutionRequest.apiData.usersRating.rate,
                        comment: this.solutionRequest.apiData.usersRating.comment
                      }
                    }
                }
            },
            "ratingPostResult.loaded": function () {
                if (this.ratingPostResult.loaded && !this.ratingPostResult.error) {
                    this.$emit('addedRating', {
                      "rate": this.ratingPostResult.apiData.rate,
                      "comment": this.ratingPostResult.apiData.comment,
                      "averageRating": this.ratingPostResult.apiData.averageRating,
                      "ratingCount": this.ratingPostResult.apiData.ratingCount,
                      "commentCount": this.ratingPostResult.apiData.commentCount,
                      "solutionId": this.ratingPostResult.apiData.solutionId,
                      "next": this.next,
                    });
                }
            },
            "solutionId": function () {
                this.solutionRequest = services.rankTheCodeService.getSolution(this.solutionId);
            },
        }
    }
</script>

<style scoped>
    .panel-title {
      margin-bottom: 1rem;
    }

    .comment-input {
      border: none;
      display: flex;
      padding: 2rem 2rem;
      background-color: #F4F8FB !important;
      border-radius: 10px;
      align-items: flex-end;
      overflow-x: hidden;
    }
</style>
